import React, { useEffect } from 'react';
import AixueFooter from '@/components/AixueFooter/index';
import AixueHeader from '@/components/AixueHeader/index';
import Screen1 from './Screen1/index';
import Screen2 from './Screen2/index';
import Screen3 from './Screen3/index';
import Screen4 from './Screen4/index';
import Screen5 from './Screen5/index';
import Screen6 from './Screen6/index';
import Screen7 from './Screen7/index';
import Screen8 from './Screen8/index';
import 'animate.css';
import styles from './index.module.scss';

export default function AixueHome() {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    return () => {
      document.body.style.overflow = originalOverflow || 'scroll';
    };
  }, []);

  return (
    <div className={`aixue-new-home ${styles.container}`}>
      <div className={styles['home-header']}>
        <AixueHeader title="爱学" />
      </div>
      <div className={styles.contentWrap}>
        <Screen1 />
        <Screen2 />
        <Screen3 />
        <Screen4 />
        <Screen5 />
        <Screen6 />
        <Screen7 />
        <Screen8 />
      </div>
      <div className={styles['footer-snap']}>
        <AixueFooter />
      </div>
    </div>
  );
}
